// src/utils/menuTransform.js

function safeStr(v) {
  const s = String(v ?? "").trim();
  return s.length ? s : "";
}

export function normalizeMenuRow(row) {
  return {
    menu_id: row.menu_id ?? row.MENU_ID ?? null,
    school_id: row.school_id ?? row.SCHOOL_ID ?? null,
    role_code: safeStr(row.role_code ?? row.ROLE_CODE).toUpperCase(),
    group_label: safeStr(row.group_label ?? row.GROUP_LABEL),
    item_label: safeStr(row.item_label ?? row.ITEM_LABEL),
    item_path: safeStr(row.item_path ?? row.ITEM_PATH),
    sort_order: Number(row.sort_order ?? row.SORT_ORDER ?? 0) || 0,
    is_active: safeStr(row.is_active ?? row.IS_ACTIVE).toUpperCase() === "N" ? "N" : "Y",
    created_at: row.created_at ?? row.CREATED_AT ?? null,
    updated_at: row.updated_at ?? row.UPDATED_AT ?? null,
  };
}

/**
 * Build sidebar menus for one role
 * Output:
 * [
 *   { label:"Dashboard", path:"/dashboard" },
 *   { label:"Students", children:[{label:"Manage Students", path:"..."}, ...] },
 * ]
 */
export function buildSidebarMenus(rows, roleCode) {
  const list = (rows || [])
    .map(normalizeMenuRow)
    .filter((r) => r.role_code === String(roleCode || "").toUpperCase())
    .filter((r) => r.is_active !== "N")
    .filter((r) => r.item_label && r.item_path);

  // group buckets
  const groups = new Map();

  for (const r of list) {
    const g = r.group_label || ""; // empty group => treat as direct link group
    if (!groups.has(g)) groups.set(g, []);
    groups.get(g).push(r);
  }

  const result = [];

  // direct links (no group_label)
  const direct = (groups.get("") || []).sort(
    (a, b) => (a.sort_order - b.sort_order) || a.item_label.localeCompare(b.item_label)
  );
  for (const r of direct) {
    result.push({ label: r.item_label, path: r.item_path });
  }

  // grouped links
  const groupKeys = Array.from(groups.keys()).filter((k) => k !== "");
  groupKeys.sort((a, b) => a.localeCompare(b));

  for (const g of groupKeys) {
    const children = (groups.get(g) || []).sort(
      (a, b) => (a.sort_order - b.sort_order) || a.item_label.localeCompare(b.item_label)
    );
    result.push({
      label: g,
      children: children.map((x) => ({ label: x.item_label, path: x.item_path })),
    });
  }

  return result;
}
